










import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class Category extends Vue {
  @Prop() category;
  onCategoryClick(category) {
    if (category.children) {
      this.$router.push({ path: `/subcategory/${category.id}` });
    } else {
      this.$router.push({ name: 'Findjobs' });
    }
    this.$emit('category-click', category);
  }
}
